<template>
	<ion-app :class="appClasses">
		<migration />
		<component v-if="mounted && mountComponent == 'ForceUpdate'" :is="ForceUpdateComponent" />
		<component v-if="mounted && mountComponent == 'Maintenance'" :is="MaintenanceComponent" />
		<component v-if="mounted && mountComponent == 'App'" :is="AppComponent" />
	</ion-app>
</template>

<script setup lang="ts">
import AppComponent from "./App.vue"
import ForceUpdateComponent from "./ForceUpdate.vue"
import MaintenanceComponent from "./Maintenance.vue"
import Migration from "./components/Migration/MigrationComponent.vue"

import { App } from "@capacitor/app"
import { Capacitor } from "@capacitor/core"
import { IonApp } from "@ionic/vue"
import { ref, computed, onMounted } from "vue"
import { useRouter, useRoute } from "vue-router"
import { StatusBar, Style } from "@capacitor/status-bar"
import { useIonRouter } from "@ionic/vue"

const route = useRoute()
const router = useRouter()
const ionRouter = useIonRouter()
const mounted = ref(false)
const mountComponent = ref()

const appClasses = computed(() => {
	let classes = "platform-" + Capacitor.getPlatform()
	classes += Capacitor.isNativePlatform() ? " platform-native" : " platform-not-native"
	return classes
})

onMounted(async () => {
	if (route.name == "forceUpdate") {
		mountComponent.value = "ForceUpdate"
	} else if (route.name == "maintenance") {
		mountComponent.value = "Maintenance"
	} else {
		mountComponent.value = "App"
	}

	App.addListener("backButton", (data) => {
		if (!ionRouter.canGoBack()) {
			App.exitApp()
		}
	})

	App.addListener("appStateChange", appStateChanged)
	mounted.value = true
})

const setStatusBarColor = () => {
	if (!Capacitor.isNativePlatform()) {
		return
	}
	if (!["/map", "/login"].includes(router.currentRoute.value.fullPath)) {
		if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
			StatusBar.setStyle({ style: Style.Dark })
		} else {
			StatusBar.setStyle({ style: Style.Light })
		}
	} else if (["/map"].includes(router.currentRoute.value.fullPath)) {
		StatusBar.setStyle({ style: Style.Light })
	}
}

const appStateChanged = async ({ isActive }) => {
	if (isActive) {
		setStatusBarColor()
	}
}
</script>

<style>
/* .platform-native.md ion-header ion-toolbar:first-child {
	padding-top: var(--ion-safe-area-top, 0);
}

.platform-native.md ion-modal ion-header ion-toolbar:first-child {
	padding-top: 0;
}
 */

/* .platform-native.md .action-sheet-group:last-child {
	padding-bottom: calc(var(--ion-safe-area-bottom) + 3em);
} */
</style>
